<template>
  <div class="forum">
    <div class="bread">
      <router-link :to="{ name: 'Community' }">社区</router-link>
      <span class="slash">/</span>
      <span class="current">发表帖子</span>
    </div>
    <div class="comment-box">
      <el-form :model="postForm" :rules="rules" ref="postForm" class="demo-ruleForm">
        <el-form-item required class="title">
          <el-row :gutter="20" class="hd">
            <el-col :span="10">
              <el-form-item prop="title">
                <el-input v-model="postForm.title" maxlength="100" placeholder="请输入标题"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <span class="tips">还可输入{{ maxTitleLength }}字符</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item prop="content" class="content-box">
          <quill-editor
            v-model="postForm.content"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
          ></quill-editor>
        </el-form-item>
        <el-form-item prop="group" class="group">
          <p class="label">全部小组</p>
          <ul class="group-list">
            <li
              :class="postForm.group === index ? 'active' : ''"
              v-for="(item, index) in myGroup"
              :key="index"
              @click="selectGroup(index)"
            >{{ item.name }}</li>
          </ul>
        </el-form-item>
        <el-form-item label="验证码" class="code-box">
          <div class="box">
            <div class="code">
              <el-form-item prop="code">
                <el-input v-model="postForm.code" placeholder="请输入验证码"></el-input>
              </el-form-item>
              <img class="code-img" :src="imgCode.img" @click="getImgCode" />
            </div>
            <button class="comment-submit" type="button" @click="submitForm('postForm')">发表帖子</button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommunityPost",
  data() {
    const that = this;
    const toolOptions = [
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      [
        {
          header: 1
        },
        {
          header: 2
        }
      ],
      [
        {
          list: "ordered"
        },
        {
          list: "bullet"
        }
      ],
      [
        {
          script: "sub"
        },
        {
          script: "super"
        }
      ],
      [
        {
          indent: "-1"
        },
        {
          indent: "+1"
        }
      ],
      [
        {
          direction: "rtl"
        }
      ],
      [
        {
          header: [1, 2, 3, 4, 5, 6, false]
        }
      ],
      [
        {
          color: []
        },
        {
          background: []
        }
      ],
      [
        {
          font: []
        }
      ],
      [
        {
          align: []
        }
      ],
      ["clean"],
      ["link", "image"]
    ];
    const uploadConfig = {
      name: "img", // 必填参数 文件的参数名
      // size: 500, // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
      accept: "image/png, image/gif, image/jpeg, image/bmp, image/x-icon" // 可选 可上传的图片格式
    };
    const handlers = {
      image: function image() {
        var self = this;
        var fileInput = this.container.querySelector(
          "input.ql-image[type=file]"
        );
        if (fileInput === null) {
          fileInput = document.createElement("input");
          fileInput.setAttribute("type", "file");
          // 设置图片参数名
          if (uploadConfig.name) {
            fileInput.setAttribute("name", uploadConfig.name);
          }
          // 可设置上传图片的格式
          fileInput.setAttribute("accept", uploadConfig.accept);
          fileInput.classList.add("ql-image");
          // 监听选择文件
          fileInput.addEventListener("change", function() {
            const formdata = new FormData();
            formdata.append("file", fileInput.files[0]);
            async function setData() {
              let data = await that.$http.post("/api/app/public/img", formdata);
              let length = self.quill.getSelection(true).index;
              //图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
              self.quill.insertEmbed(length, "image", data.path);
              self.quill.setSelection(length + 1);
            }
            setData();
          });
          this.container.appendChild(fileInput);
        }
        fileInput.click();
      }
    };
    return {
      myGroup: [], //我的小组列表
      editorOption: {
        //  富文本编辑器配置
        theme: "snow",
        modules: {
          toolbar: {
            container: toolOptions,
            handlers: handlers // 事件重写
          }
        }
      },
      myVue: this,
      imgCode: {}, // 验证码图片
      postForm: {
        title: "",
        group: "",
        content: "",
        code: ""
      }, //发帖信息
      rules: {
        title: [
          {
            required: true,
            message: "请输入话题名称",
            trigger: "blur"
          }
        ],
        group: [
          {
            required: true,
            message: "请选择小组",
            trigger: "change"
          }
        ],
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ],
        anonymous: [
          {
            required: true,
            message: "请选择是否匿名",
            trigger: "blur"
          }
        ]
      } //发帖验证
    };
  },
  created() {
    this.getMineGroup();
    this.getImgCode();
  },
  mounted: function() {},
  computed: {
    maxTitleLength() {
      return 100 - this.postForm.title.length;
    }
  },
  methods: {
    // 获取我的小组
    async getMineGroup() {
      const that = this;
      let data = await that.$http.get("/api/app/community/group/myGroup", {
        limit: 10000
      });
      that.myGroup = data.list;
    },
    // 选择小组
    selectGroup(index) {
      this.postForm.group = index;
    },
    // 获取图形验证码
    async getImgCode() {
      const that = this;
      let data = await that.$http.get("/api/app/captcha");
      that.imgCode = data;
    },
    // 编辑器失去焦点事件
    onEditorBlur() {
      if (this.postForm.content) {
        this.$refs.postForm.clearValidate("content");
      }
    },
    //发表帖子
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate(async valid => {
        if (valid) {
          let data = await that.$http.post("/api/app/community/post", {
            group_id: that.myGroup[that.postForm.group].id,
            title: that.postForm.title,
            content: that.postForm.content,
            captcha: that.postForm.code,
            key: that.imgCode.key
          });
          that.$message({
            type: "success",
            message: "发帖成功！",
            duration: 1000,
            onClose: () => {
              that.$router.replace({
                name: "CommunityShow",
                params: {
                  id: data
                },
                query: {
                  group_id: that.myGroup[that.postForm.group].id
                }
              });
            }
          });
          that.getImgCode();
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.forum {
  padding-bottom: 60px;
  background-color: #f5f7f9;
  overflow: hidden;
  .bread {
    width: 1200px;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
  }
  .comment-box {
    margin-top: 20px;
    overflow: hidden;
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    .title {
      margin: 0 auto;
      padding: 0 24px 30px;
      background-color: #fff;
      .hd {
        padding: 30px 0 0;
        .tips {
          height: 40px;
          line-height: 40px;
          font-size: 13px;
          color: #999;
        }
      }
    }
    .content-box {
      margin: 0 0 30px;
      padding: 0 24px 30px;
      background-color: #fff;
      & /deep/ .quill-editor {
        background-color: #fff;
        border-radius: 4px;
        overflow: hidden;
        .ql-picker-label {
          display: flex;
          align-items: center;
          svg {
            display: inline-block;
            width: 18px;
            height: 18px;
          }
        }
        .ql-container {
          min-height: 200px;
          border-radius: 0 0 4px 4px;
        }
        .ql-snow {
          border: 1px solid #dcdfe6;
        }
        .ql-toolbar {
          border-bottom: none;
          border-radius: 4px 4px 0 0;
        }
      }
    }
    .group {
      margin: 0 0 30px;
      padding: 30px 24px;
      background-color: #fff;
      .label {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #20242a;
        line-height: 16px;
      }
      .group-list {
        padding: 30px 26px 0;
        overflow: hidden;
        li {
          float: left;
          height: 34px;
          margin-bottom: 30px;
          margin-right: 40px;
          padding: 0 20px;
          background-color: #f4f4f4;
          border-radius: 15px;
          text-align: center;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #595959;
          line-height: 34px;
          cursor: pointer;
        }
        .active {
          position: relative;
          background-color: #d9d9d9;
          &:after {
            position: absolute;
            top: -3px;
            right: -3px;
            display: block;
            width: 16px;
            height: 16px;
            background: url("~@/assets/images/icon_fourm_group_check.png")
              center no-repeat rgba(0, 0, 0, 0.1);
            background-size: 16px 16px;
            border-radius: 50%;
            z-index: 999;
            content: "";
          }
        }
      }
    }
    .code-box {
      .box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .code {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .code-img {
            margin-left: 15px;
          }
        }
        .comment-submit {
          display: block;
          width: 88px;
          height: 32px;
          border: none;
          background-color: $primary-color;
          cursor: pointer;
          border-radius: 4px;
          text-align: center;
          font-size: 14px;
          color: #fff;
          line-height: 32px;
          outline: none;
        }
      }
    }
  }
}
</style>
